import { render, staticRenderFns } from "./QuestionMark.vue?vue&type=template&id=5f16fec2&"
import script from "./QuestionMark.vue?vue&type=script&lang=js&"
export * from "./QuestionMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports